// src/components/CcpAdminArchivedData/inc/SchoolChangeForm.jsx
import React from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import useFirestore from "../../../../config/fireBaseHook";
import { CircularProgress, Box } from "@mui/material";
import { formatDateTime } from "../../../../utils/formatDate";

const SchoolChangeForm = () => {
  const { data, loading, error } = useFirestore(
    "SchoolChangeForm",
    "created_at",
    "desc",
  );

  const columns = [
    {
      field: "created_at",
      headerName: "Date Submitted",
      flex: 1,
      renderCell: (params) => formatDateTime(params.row?.created_at),
    },
    { field: "schoolName", headerName: "School Name", flex: 1 },
    { field: "fromName", headerName: "From Name", flex: 1 },
    { field: "student_name", headerName: "Student Name", flex: 1 },
    { field: "dob", headerName: "DOB", flex: 0.8 },
    { field: "ssid", headerName: "SSID", flex: 0.8 },
    { field: "grad_year", headerName: "Grad Year", flex: 0.8 },
    { field: "prev_school", headerName: "Previous School", flex: 1 },
    { field: "stopped_attending", headerName: "Stopped Attending", flex: 1 },
    {
      field: "currently_attending",
      headerName: "Currently Attending",
      flex: 1,
    },
    { field: "attending_date", headerName: "Attending Date", flex: 1 },
    { field: "signed_name", headerName: "Signed Name", flex: 1 },
    { field: "schoolId", headerName: "School ID", flex: 0.6 },
    { field: "pathwayEmail", headerName: "Pathway Email", flex: 1 },
    { field: "opEmail", headerName: "OP Email", flex: 1 },
  ];

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <Box sx={{ height: "calc(100vh - 200px)", width: "100%" }}>
      <AppDataGrid
        rows={data}
        columns={columns}
        loading={loading}
        slots={{ toolbar: GridToolbarNoExport }}
        getRowId={(row) => row.id}
        pagination
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        disableSelectionOnClick
      />
    </Box>
  );
};

export default SchoolChangeForm;
